import { Box, Button, TextField } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import { StandSelector } from "./StandSelector";
import { PassTypeSelector } from "./PassTypeSelector";
import { PassShapeSelector } from "./PassShapeSelector";
import { ShowOnlyActivesCheckbox } from "@/controls/filters/ShowOnlyActivesCheckbox";

interface PassIdsToolbarProps {
	search: string;
	onSearchChange: (value: string) => void;
	standId: number | null;
	onStandChange: (value: number | null) => void;
	passTypeId: number | null;
	onPassTypeChange: (value: number | null) => void;
	passShapeId: number | null;
	onPassShapeChange: (value: number | null) => void;
	onlyActives: boolean;
	onOnlyActivesChange: (value: boolean) => void;
	onAdd: () => void;
}

export const PassIdsToolbar = ({
	search,
	onSearchChange,
	standId,
	onStandChange,
	passTypeId,
	onPassTypeChange,
	passShapeId,
	onPassShapeChange,
	onlyActives,
	onOnlyActivesChange,
	onAdd,
}: PassIdsToolbarProps) => {
	return (
		<Box
			sx={{
				display: "flex",
				alignItems: "center",
				gap: 2,
				mb: 1,
				p: 1,
				backgroundColor: "background.paper",
				borderRadius: 1,
			}}
		>
			<TextField
				size="small"
				placeholder="Search pass IDs..."
				value={search}
				onChange={(e) => onSearchChange(e.target.value)}
				sx={{ width: 200 }}
			/>

			<StandSelector value={standId} onChange={onStandChange} includeAll />
			<PassTypeSelector
				value={passTypeId}
				onChange={onPassTypeChange}
				includeAll
			/>
			<PassShapeSelector
				value={passShapeId}
				onChange={onPassShapeChange}
				includeAll
			/>

			<ShowOnlyActivesCheckbox
				checked={onlyActives}
				onChange={onOnlyActivesChange}
			/>

			<Box sx={{ flex: 1 }} />

			<Button
				variant="contained"
				color="primary"
				startIcon={<AddIcon />}
				onClick={onAdd}
				size="small"
			>
				Add Pass ID
			</Button>
		</Box>
	);
};
